import { ENDPOINT_TTS } from "@memorang/constants/src/urls";
import * as Crypto from "expo-crypto";

export const getTtsAudioData = async (
	explanation: string,
	elevenLabsVoiceId: string,
	appName: string,
	cacheKey: string,
	shouldStream?: boolean,
) => {
	const params = new URLSearchParams({
		text: explanation,
		voiceId: elevenLabsVoiceId,
		shouldStream: String(!!shouldStream),
		appName,
		cacheKey,
	});

	const response = await fetch(`${ENDPOINT_TTS}?${params}`);
	const contentType = response.headers.get("content-type");

	if (contentType?.includes("application/json")) {
		const data = await response.json();
		return data.audio;
	}

	if (shouldStream) {
		return response.body;
	}
	const data = await response.json();
	return data.audio;
};

export const getTTSCacheKey = async (
	org: string,
	tenantId: string,
	appId: string,
	transcript: string,
) => {
	const transcriptHash = (
		await Crypto.digestStringAsync(
			Crypto.CryptoDigestAlgorithm.SHA256,
			transcript,
		)
	).slice(0, 8);
	return `${org}:${tenantId}:${appId}:TTS:${transcriptHash}`;
};
